<div
    class="cmps-ca-guide-card--card cmps-cdk-border-color-blue-100 cmps-cdk-bg-color-blue-300"
>
    <cmps-badge
        class="cmps-ca-guide-card--badge"
        [cmpsBadge]="_i18n.__RECOMMENDED | translate"
        cmpsBadgeClassName="cmps-cdk-bg-color-green-100"
        *ngIf="guide.recommended === true"
    ></cmps-badge>
    <div class="cmps-ca-guide-card--name cmps-cdk-color-blue-100">
        {{ guide.name }}
    </div>
    <div class="cmps-ca-guide-card--meta">
        <div class="cmps-ca-guide-card--meta-item">
            <div
                class="cmps-ca-guide-card--meta-icon cmps-cdk-bg-color-blue-300 cmps-cdk-border-color-blue-100"
            >
                <cmps-icon
                    svgIcon="format-list-group"
                    class="cmps-cdk-w-18px cmps-cdk-h-18px cmps-cdk-nested:cmps-cdk-w-inherit cmps-cdk-nested:cmps-cdk-h-inherit cmps-cdk-fill-blue-100"
                    aria-hidden="true"
                ></cmps-icon>
            </div>
            <div>
                <div
                    class="cmps-ca-guide-card--meta-label cmps-cdk-color-grey-400"
                >
                    {{ _i18n._11346_SECTIONS | translate }}
                </div>
                <div class="cmps-ca-guide-card--meta-value">
                    {{ guide.numOfGroups }}
                </div>
            </div>
        </div>
        <div class="cmps-ca-guide-card--meta-item">
            <div
                class="cmps-ca-guide-card--meta-icon cmps-cdk-bg-color-blue-300 cmps-cdk-border-color-blue-100"
            >
                <cmps-icon
                    svgIcon="help-circle-outline"
                    class="cmps-cdk-w-18px cmps-cdk-h-18px cmps-cdk-nested:cmps-cdk-w-inherit cmps-cdk-nested:cmps-cdk-h-inherit cmps-cdk-fill-blue-100"
                    aria-hidden="true"
                ></cmps-icon>
            </div>
            <div>
                <div
                    class="cmps-ca-guide-card--meta-label cmps-cdk-color-grey-400"
                >
                    {{ _i18n._11347_QUESTIONS | translate }}
                </div>
                <div class="cmps-ca-guide-card--meta-value">
                    {{ guide.numOfAreas }}
                </div>
            </div>
        </div>
    </div>
    <div
        *ngIf="reasonText != null"
        class="cmps-ca-guide-card--reason"
        (click)="_toggleReason()"
    >
        <button
            type="button"
            class="cmps-ca-guide-card--reason-btn cmps-cdk-color-grey-400"
            [attr.aria-expanded]="_reasonExpanded"
        >
            <strong>{{ _i18n._11352_WHY_THIS_GUIDE | translate }}</strong>
        </button>
        <div
            class="cmps-ca-guide-card--reason-content"
            [class.cmps-ca-guide-card--reason-content--expanded]="
                _reasonExpanded
            "
        >
            <p class="cmps-cdk-color-grey-400">{{ reasonText }}</p>
        </div>
    </div>
</div>
